(() => {
  if (window.__navigationScrollInit) return;
  window.__navigationScrollInit = true;

  const MOBILE_MAX_WIDTH = 949;

  function scrollActiveIntoView(list) {
    if (!list || window.innerWidth > MOBILE_MAX_WIDTH) return;

    const activeLink = list.querySelector('.navigation__link--active');
    if (!activeLink) return;

    const item = activeLink.closest('.navigation__item');
    if (!item) return;

    const maxScroll = list.scrollWidth - list.clientWidth;
    if (maxScroll <= 0) return;

    const listRect = list.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    let nextScroll = list.scrollLeft;

    if (itemRect.right > listRect.right) {
      nextScroll += itemRect.right - listRect.right;
    } else if (itemRect.left < listRect.left) {
      nextScroll -= listRect.left - itemRect.left;
    } else {
      return;
    }

    list.scrollLeft = Math.max(0, Math.min(maxScroll, nextScroll));
  }

  function initNavigationLists() {
    document.querySelectorAll('[data-navigation-list]').forEach(scrollActiveIntoView);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavigationLists, { once: true });
  } else {
    initNavigationLists();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const list = event.target.querySelector('[data-navigation-list]');
    if (list) scrollActiveIntoView(list);
  });
})();
